const nameDictionary = {
    cantidadCompra: {
        es: "Cantidad compra",
        en: "Quantity purchase",
    },
    cantidadNominal: {
        es: "Cantidad nominal",
        en: "Nominal quantity",
    },
    cantidadOperaciones: {
        es: "Cant. de operaciones",
        en: "Number of transactions",
    },
    cantidadVenta: {
        es: "Cantidad venta",
        en: "Quantity sale",
    },
    cantidadDias: {
        es: "Cant. de Días",
        en: "Number of days",
    },
    categoria: {
        es: "Categoría",
        en: "Category",
    },
    categoriaDescripcion: {
        es: "Descripción de la categoría",
        en: "Category description",
    },
    chequeNumero: {
        es: "Cheque Nro.",
        en: "Check No.",
    },
    cierreAnt: {
        es: "Cierre Ant.",
        en: "Previous closing price",
    },
    clase: {
        es: "Clase",
        en: "Class",
    },
    descripcion: {
        es: "Descripción",
        en: "Description",
    },
    diaria: {
        es: "Diaria",
        en: "Daily",
    },
    esDestacado: {
        es: "Destacado",
        en: "Featured",
    },
    esLider: {
        es: "Lider",
        en: "Leader",
    },
    estado: {
        es: "Estado",
        en: "Status",
    },
    fecha: {
        es: "Fecha",
        en: "Date",
    },
    fechaVencimiento: {
        es: "Vencimiento",
        en: "Expiration",
    },
    fechaVto: {
        es: "Fecha VTO.",
        en: "Expiration",
    },
    formaOperativa: {
        es: "Forma operativa",
        en: "Operational form",
    },
    frecuenciaVariacionPreferida: {
        es: "Frecuencia de variarión preferida",
        en: "Preferred frequency of variance",
    },
    horaUltimaNovedad: {
        es: "Última novedad",
        en: "Latest news",
    },
    horario: {
        es: "Horario min/max",
        en: "Schedule min/max",
    },
    horarioMaximo: {
        es: "Horario máximo",
        en: "Maximum schedule",
    },
    horarioMinimo: {
        es: "Horario mínimo",
        en: "Minimum schedule",
    },
    horizonte: {
        es: "Horizonte",
        en: "Horizonte",
    },
    id: {
        es: "ID",
        en: "ID",
    },
    indice: {
        es: "Índice",
        en: "Index",
    },
    interesAbierto: {
        es: "Interés abierto",
        en: "Open interest",
    },
    mercado: {
        es: "Mercado",
        en: "Market",
    },
    meses1: {
        es: "30 días",
        en: "30 days",
    },
    meses12: {
        es: "1 Año",
        en: "1 year",
    },
    meses6: {
        es: "6 meses",
        en: "6 months",
    },
    moneda: {
        es: "Moneda",
        en: "Currency",
    },
    montoAInvertir: {
        es: "Monto a invertir",
        en: "Investment amount",
    },
    montoCOL: {
        es: "Monto Col.",
        en: "Col. amount",
    },
    montoOperado: {
        es: "Monto operado",
        en: "Amount traded",
    },
    montoTOM: {
        es: "Monto Tom.",
        en: "Tom. amount",
    },
    numero: {
        es: "Número",
        en: "Number",
    },
    oferta: {
        es: "Oferta comp./vta.",
        en: "Offer sell/buy",
    },
    ofertaCompra: {
        es: "Oferta compra",
        en: "Buy offer",
    },
    ofertaVenta: {
        es: "Oferta venta",
        en: "Sell offer",
    },
    plazo: {
        es: "Plazo",
        en: "Term",
    },
    plazoRescate: {
        es: "Plazo de rescate",
        en: "Redemption period",
    },
    precioAper: {
        es: "Aper.",
        en: "Opening price",
    },
    precioApertura: {
        es: "Precio de apertura",
        en: "Opening price",
    },
    precioCierre: {
        es: "Precio de cierre",
        en: "Closing price",
    },
    precioCierreAnterior: {
        es: "Precio de cierre anterior",
        en: "Previous closing price",
    },
    precioMax: {
        es: "Máx.",
        en: "Max.",
    },
    precioMaximo: {
        es: "Precio máximo",
        en: "Maximum price",
    },
    precioMejorOrdenCompra: {
        es: "Precio de mejor orden de compra",
        en: "Best bid price",
    },
    precioMejorOrdenVenta: {
        es: "Precio de mejor orden de venta",
        en: "Best ask price",
    },
    precioMin: {
        es: "Mín.",
        en: "Min.",
    },
    precioMinimo: {
        es: "Precio mínimo",
        en: "Minimum price",
    },
    precioPromedioPonderado: {
        es: "Precio promedio ponderado",
        en: "Weighted average price",
    },
    precioUltimaOperacion: {
        es: "Último precio",
        en: "Last trade price",
    },
    precioUltimo: {
        es: "Último precio",
        en: "Last price",
    },
    securityId: {
        es: "ID de seguridad",
        en: "Security ID",
    },
    segmento: {
        es: "Segmento",
        en: "Segment",
    },
    semana: {
        es: "Semana",
        en: "Week",
    },
    sgrLibradorAlmacenadora: {
        es: "SGR/Libr/ Almacenadora",
        en: "Guaranteeing SGR WHS",
    },
    simbolo: {
        es: "Símbolo",
        en: "Symbol",
    },
    sociedadGerente: {
        es: "Sociedad gerente",
        en: "Managing company",
    },
    subastaNumero: {
        es: "Subasta número",
        en: "Auction number",
    },
    tipo: {
        es: "Tipo",
        en: "Type",
    },
    TNACOL: {
        es: "TNA COL.",
        en: "TNA COL.",
    },
    TNATOM: {
        es: "TNA TOM.",
        en: "TNA TOM.",
    },
    ultimaAct: {
        es: "Última Act.",
        en: "Latest news",
    },
    ultimaOperacion: {
        es: "Últ. Oper.",
        en: "Last trade",
    },
    valorNominal: {
        es: "Valor nominal",
        en: "Face value",
    },
    variacion: {
        es: "Variación",
        en: "Variance",
    },
    volumen : {
        es: "Volumen",
        en: "Volume",
    },
    ytd: {
        es: "YTD",
        en: "YTD",
    },
    lastMonth: {
        es: "Variación último mes",
        en: "Last month variance",
    },
    last12Months: {
        es: "Variación último año",
        en: "Last year variance",
    },
};

export default nameDictionary;
